export class PaymentBoletoRequestDto {

	contractId: number;
	documentId: string;
	dueDate: string;
	uuid: string;

	constructor() {
	}
}